import { useAtom, useAtomValue } from 'jotai';
import {
  bookingBoatIdAtom,
  bookingDurationAtom,
  selectedBookingPackageAtom,
  bookingTripTimeAtom,
  tripStartDayjsAtom,
  tripStartFormattedAtom,
} from 'components/forms/bookingWidget/jotaiStore';
import { useBoatDetails } from 'components/pdp/v3/hooks';
import { useDefaultStartTimes } from 'hooks/queries';
// Custom hooks for separation of concerns
export const useTimePickerData = () => {
  const bookingBoatId = useAtomValue(bookingBoatIdAtom);
  const bookingDuration = useAtomValue(bookingDurationAtom);
  const selectedBookingPackage = useAtomValue(selectedBookingPackageAtom);
  const tripStart = useAtomValue(tripStartDayjsAtom);
  const tripStartFormatted = useAtomValue(tripStartFormattedAtom);
  const [tripTime, setTripTime] = useAtom(bookingTripTimeAtom);

  const { boatDetails: bookingBoatDetails } = useBoatDetails(bookingBoatId);
  const { defaultStartTimes } = useDefaultStartTimes();

  return {
    bookingBoatId,
    bookingDuration,
    selectedBookingPackage,
    tripStart,
    tripStartFormatted,
    tripTime,
    setTripTime,
    bookingBoatDetails,
    defaultStartTimes,
  };
};
